export const COMPANY_INFO = {
  name: "Sakskær Auto",
  address: "Sakskærvej 75",
  zipCity: "6800 Varde",
  fullAddress: "Sakskærvej 75, 6800 Varde",
  mapsUrl: "https://www.google.com/maps/place/Saksk%C3%A6rvej%2075,%206800%20Varde",
  cvr: "34300755",
  phone: "23 95 27 06",
  phoneRaw: "23952706",
  email: "sakskaer-auto@outlook.dk",
  facebookUrl: "https://www.facebook.com/people/Saksk%C3%A6r-Auto/61562551081687/",
  logoUrl: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/black-logo-no-background-scaled.png"
}

export const COMMON_FEATURES = [
  {
    title: "Erfaring og ekspertise",
    desc: "Vi kender både nye og ældre biler, og vores erfaring sikrer dig en professionel løsning hver gang."
  },
  {
    title: "Hurtig og effektiv service",
    desc: "Vi arbejder effektivt og organiseret, så du slipper for unødvendige ventetider."
  },
  {
    title: "Ærlig rådgivning",
    desc: "Hos os ved du altid, hvad du betaler for – ingen skjulte gebyrer, kun ærlig service."
  }
]

export const SUBPAGE_DESIGN_DATA = {
  "a-c-service": {
    tagline: "Service og reparation til fair priser — uden overraskelser",
    headerBlock: {
      block1Title: "Forebygger fejl og skader",
      block1Text: "Med tiden forsvinder kølemidlet naturally, hvilket kan føre til slid og dyre skader på kompressoren. Ved at holde systemet fyldt og vedligeholdt undgår du disse problemer.",
      block2Title: "Effektiv dugfjernelse",
      block2Text: "Et velfungerende airconditionanlæg hjælper med hurtigt at fjerne dug fra ruderne, hvilket forbedrer udsynet og øger sikkerheden."
    },
    splitCard: {
      image: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/imgi-18-bil-3-scaled.jpg",
      block1Title: "Fejlfinding med brint — præcis og effektiv lækagesøgning",
      block1Text: "Hos Sakskær Auto anvender vi det nyeste testudstyr og har mulighed for at foretage præcis fejlfinding på utætte A/C-systemer med brint. Det gør det muligt at lokalisere selv de mindste utætheder hurtigt og sikkert – og sikre, at din bils aircondition virker optimalt igen.",
      block2Title: "Vi servicerer alle bilers A/C-anlæg",
      block2Text: "Uanset om du kører i en benzin-, diesel-, hybrid- eller elbil, kan vi servicere dit klimaanlæg. Vores udstyr er kompatibelt med alle gængse kølemidler, inklusive det nyere CO₂-system, som findes i nogle elbiler.",
      buttonText: "Indhent et tilbud",
      buttonLink: "/kontakt/"
    }
  },
  "daek-og-faelge": {
    tagline: "Service og reparation til fair priser — uden overraskelser",
    headerBlock: {
      block1Title: "Stort udvalg af sommer-, vinter- og helårsdæk",
      block1Text: "Vi hjælper dig med at vælge de helt rigtige dæk og fælge, som matcher din bil, dine kørselsbehov og dit budget for maksimal vejbeliggenhed.",
      block2Title: "Præcis afbalancering og sikkerhed",
      block2Text: "Korrekt afbalancering og præcis montering minimerer dækslitagen, reducerer støj i kabinen og sikrer dig en behagelig køretur."
    },
    splitCard: {
      image: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/imgi-15-daek-faelge-scaled.jpg",
      block1Title: "Hvorfor vælge Sakskær Auto til dine dæk og fælge?",
      block1List: [
        "Vi har mange års erfaring og ekspertise med alle typer dæk og fælge",
        "Vi bruger moderne udstyr til præcis montering og afbalancering",
        "Vi sikrer, at dine TPMS-ventiler fungerer korrekt og opfylder fabrikantens krav",
        "Du får altid professionel og ærlig vejledning, der matcher dine behov og budget",
        "Hurtig og effektiv service, så du hurtigt kan komme sikkert videre"
      ],
      block1Text: "",
      block2Title: "Sakskær Auto – Din lokale dækspecialist i Varde",
      block2Text: "Som dit lokale autoværksted i Varde sætter vi en ære i at tilbyde dæk og fælge af høj kvalitet med god service til fair priser. Kontakt os i dag, og få et uforpligtende tilbud på dine nye dæk eller fælge. Vi sørger for, at din bil er klar til vejen – sikkert og komfortabelt.",
      buttonText: "Indhent et tilbud",
      buttonLink: "/kontakt/"
    }
  },
  "gearkasse-service": {
    tagline: "Service og reparation til fair priser – uden overraskelser",
    headerBlock: {
      block1Title: "Ved at få skiftet gearolie og efterset gearkassen regelmæssigt, kan du:",
      block1List: [
        "Forebygge dyre reparationer og slid på gearkomponenter",
        "Sikre en mere jævn og præcis gearskiftoplevelse",
        "Forlænge gearkassens levetid og optimere bilens ydeevne",
        "Undgå fejl og problemer med automatiske eller manuelt betjente gearkasser"
      ],
      block1Text: "",
      block2Title: "",
      block2Text: ""
    },
    splitCard: {
      image: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/content-7-scaled.jpg",
      block1Title: "Professionel gearkasse service hos Sakskær Auto",
      block1Text: "Vi bruger det nyeste udstyr og kvalitetsgearolie, der passer præcist til din bilmodel. Vores erfarne mekanikere tjekker gearkassen grundigt og rådgiver dig om den bedste løsning – altid med fokus på at sikre, at din bil kører trygt og problemfrit.",
      block2Title: "Bestil gearkasse service i dag – undgå fremtidige problemer",
      block2Text: "Hos Sakskær Auto i Varde kan du få udført gearkasse service hurtigt og effektivt. Mange gange kan en simpel service spare dig for store udgifter senere.\n\nKontakt os i dag og få en tid til gearkasse service – vi hjælper dig med at passe på din bil.",
      buttonText: "Indhent et tilbud",
      buttonLink: "/kontakt/"
    }
  },
  "gearkasse-skylning": {
    tagline: "Service og reparation til fair priser — uden overraskelser",
    headerBlock: {
      block1Title: "100% udskiftning af den gamle gearolie",
      block1Text: "Ved et almindeligt skift bliver op mod 40-50% af olien i konverteren og oliekøleren. Med en automatisk gearkasse skylning udskiftes 100% af olien grundigt og skånsomt.",
      block2Title: "Løsning mod ru gearskift og hakkevise udkoblinger",
      block2Text: "Hvis din automatgearkasse tøver eller skifter hårdt, kan en skylning med rensemiddel ofte genoprette gearkassens oprindelige kørekomfort uden dyre reparationer."
    },
    splitCard: {
      image: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/gearkasse-skylning.jpg",
      block1Title: "Gennemspuling af ventilhus og konverter med specialudstyr",
      block1Text: "Med vores avancerede specialudstyr skylles hele automatgearkassen igennem under kontrolleret tryk. Dette sikrer, at alle aflejringer, sod, koks og metalpartikler renses grundigt ud af både ventilhus, oliekøler, slanger og momentsconverter, før ny frisk og godkendt gearolie påfyldes.\n\nEn traditionel olieaftapning fjerner ofte kun halvdelen af olien, da resten forbliver i converteren og oliekøleren. Med vores professionelle skylleudstyr udskiftes 100% af olien, så din gearkasse får helt rene driftsbetingelser og maksimal levetid.",
      block2Title: "Professionel vurdering og diagnose hos Sakskær Auto i Varde",
      block2Text: "Før vi udfører en gearkasse skylning, foretager vores erfarne mekanikere en grundig test og fejlsøgning af automatgearkassens tilstand. Vi udlæser fejlkoder og tjekker oliens kvalitet for at sikre, at en skylning er den helt rigtige løsning for din bil.\n\nHvis din automatgearkasse tøver ved gearskift, skifter hårdt eller har uregelmæssige omdrejninger, kan en professionel skylning hos Sakskær Auto i Varde ofte genoprette den originale, bløde gearskiftfornemmelse uden behov for bekostelige reparationer. Kontakt os i dag for faglig rådgivning eller for at booke en tid.",
      buttonText: "Indhent et tilbud",
      buttonLink: "/kontakt/"
    }
  },
  "kundebil": {
    tagline: "Service og reparation til fair priser — uden overraskelser",
    headerBlock: {
      block1Title: "Hvorfor vælge Sakskær Auto?",
      block1List: [
        "Professionelt autoværksted i Varde med mange års erfaring",
        "Gratis lånebil ved service og reparation – for din bekvemmelighed",
        "Hurtig og effektiv service, så du ikke er uden bil længere end højst nødvendigt",
        "Professionel rådgivning og kvalitetsarbejde med det nyeste udstyr"
      ],
      block1Text: "",
      block2Title: "",
      block2Text: ""
    },
    splitCard: {
      image: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/523175374-17887908078318194-7009705061051321505-n.jpg",
      block1Title: "Sakskær Auto – dit lokale autoværksted i Varde",
      block1Text: "Vi ønsker at gøre det så nemt som muligt for dig at få din bil serviceret eller repareret. Med en gratis lånebil sikrer vi, at du ikke bliver sat tilbage i din hverdag.\n\nKontakt Sakskær Auto i dag, og bestil tid til service – husk at spørge efter din gratis lånebil ved booking!",
      block2Title: "",
      block2Text: "",
      buttonText: "Kontakt os i dag",
      buttonLink: "/kontakt/"
    }
  },
  "reparation": {
    tagline: "Service og reparation til fair priser — uden overraskelser",
    headerBlock: {
      block1Title: "Hurtig og præcis fejldiagnose",
      block1Text: "Med markedets nyeste test- og diagnoseudstyr finder vi hurtigt årsagen til advarselslamper, ulyde eller mekaniske svigt på din bil.",
      block2Title: "Håndværk og reservedele i topkvalitet",
      block2Text: "Vi går aldrig på kompromis med sikkerheden. Alle reparationer udføres med OE-godkendte kvalitetsreservedele med fuld garanti."
    },
    splitCard: {
      image: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/imgi-15-rep-eller-tilfaeldigt-sted-scaled.jpg",
      block1Title: "VORES VÆRKSTED TILBYDER BL.A.:",
      block1List: [
        "Serviceeftersyn og olieskift",
        "Reparation af bremser og undervogn",
        "Udskiftning af tandrem og taktkæde",
        "Koblingsskift",
        "Fejlfinding og diagnose",
        "A/C-service"
      ],
      block1Text: "",
      block2Title: "KLARGØRING TIL SYN",
      block2Text: "Alt i dæk og fælge – inkl. montering, afbalancering og opbevaring\n\nGenerelt mekanisk arbejde på alle bilmærker og modeller",
      buttonText: "Indhent et tilbud",
      buttonLink: "/kontakt/"
    }
  },
  "service": {
    tagline: "Service og reparation til fair priser – uden overraskelser",
    headerBlock: {
      block1Title: "Kun reservedele af højeste kvalitet",
      block1Text: "Vi anvender udelukkende reservedele af bedste kvalitet, som matcher eller overgår producentens egne krav. Det betyder, at du får en langtidsholdbar løsning, hvor du ikke skal bekymre dig om slid, svigt eller følgeskader.\n\nDu får altså den samme tryghed som på mærkeværkstedet – bare til en fair pris og med ærlig rådgivning.",
      block2Title: "",
      block2Text: ""
    },
    splitCard: {
      image: "",
      block1Title: "VI VED, DIN BIL SKAL VÆRE TIL AT STOLE PÅ",
      block1Text: "Din bil skal starte, når du drejer nøglen. Den skal kunne klare hverdagens krav uden problemer – og den skal være sikker for dig og din familie. Hos Sakskær Auto forstår vi det ansvar, der følger med et serviceeftersyn. Derfor får du:",
      block1List: [
        "Kvalitet og præcision i alt vi laver",
        "Service uden genveje eller halve løsninger",
        "Ærlige vurderinger og faste priser",
        "Et værksted, der respekterer både din bil og din tid"
      ],
      block2Title: "SAKSKÆR AUTO – DIT AUTOVÆRKSTED I VARDE",
      block2Text: "Vi er dit lokale valg, når du ønsker bilservice med høj kvalitet, fabriksriktige intervaller og fuld gennemsigtighed. Uanset bilmodel eller mærke, sørger vi for, at din bil bevarer sin værdi, garanti og driftssikkerhed.\n\nKontakt os i dag, og få en tid til service – så du kan køre trygt videre.",
      buttonText: "Indhent et tilbud",
      buttonLink: "/kontakt/"
    }
  },
  "udskiftning-af-tandrem-og-taktkaede": {
    tagline: "Service og reparation til fair priser – uden overraskelser",
    headerBlock: {
      block1Title: "Taktkæde – ikke altid “vedligeholdelsesfri”",
      block1Text: "Mange tror, at en taktkæde er vedligeholdelsesfri og aldrig skal skiftes – men det er desværre en udbredt misforståelse.\n\nTaktkæder kan over tid blive strakte, slide kædestrammeren op eller begynde at støje. Det kan føre til forkert tænding, nedsat motorydelse eller alvorlige motorskader, hvis kæden springer eller hopper over.",
      block2Title: "",
      block2Text: ""
    },
    splitCard: {
      image: "",
      block1Title: "Vi anbefaler regelmæssige tjek, især hvis du oplever symptomer som:",
      block1List: [
        "Raslende lyd fra motoren ved koldstart",
        "Motorfejl eller tændingsproblemer",
        "Uregelmæssig motorgang"
      ],
      block1Text: "Hos Sakskær Auto kan vi hurtigt vurdere kædens tilstand og rådgive dig om behov for udskiftning – også selvom bilen ikke har et officielt skifteinterval.",
      block2Title: "Sakskær Auto – Dit lokale værksted i Varde",
      block2Text: "Uanset om din bil kører med tandrem eller taktkæde, står vi klar til at hjælpe dig med professionel udskiftning og service. Vi servicerer både benzin-, diesel-, hybrid- og elbiler – og vi går aldrig på kompromis med kvaliteten.\n\nKontakt os i dag for et uforpligtende tilbud på tandrem eller taktkæde-udskiftning – og kør trygt videre med en motor i topform.",
      buttonText: "Indhent et tilbud",
      buttonLink: "/kontakt/"
    }
  },
  "walnut-blaster": {
    tagline: "Service og reparation til fair priser — uden overraskelser",
    headerBlock: {
      block1Title: "Skånsom og effektiv rensning af ventiler",
      block1Text: "Walnut Blaster benytter knuste valnøddeskaller under tryk til effektivt at blæse genstridig koks og sod væk fra indsugningsventilerne.",
      block2Title: "Genvind tabt motorkraft og speederrespons",
      block2Text: "Koksofhobninger blokerer lufttilførslen og forringer motorydelsen. Efter en rensning føles motoren frisk, smidig og fuld af trækkraft igen."
    },
    splitCard: {
      image: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/foer.jpg",
      block1Title: "Perfekt til direkte indsprøjtede benzin- og dieselbiler",
      block1Text: "Direkte indsprøjtningsmotorer skyller ikke ventilerne med brændstof, hvilket gør koksophobning uundgåelig med tiden.",
      block2Title: "Imponerende før- og efterresultat",
      block2Text: "Vi dokumenterer rengøringen, så du kan se den tydelige forskel på helt rene ventiler og en motor i topform.",
      buttonText: "Indhent et tilbud",
      buttonLink: "/kontakt/"
    }
  },
  "reference": {
    tagline: "Service og reparation til fair priser — uden overraskelser",
    headerBlock: {
      block1Title: "Skræddersyede løsninger til enhver bil",
      block1Text: "Vi tilpasser vores arbejde til den enkelte kundes specifikke ønsker og leverer altid resultater i tæt dialog og med højeste kvalitet.",
      block2Title: "Kompetent rådgivning fra start til slut",
      block2Text: "Gennem klar forventningsafstemning holder vi dig informeret og sikrer, at dit projekt lever fuldt ud op til dine forventninger."
    },
    splitCard: {
      image: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/tilfaeldigt-sted-750x1000.jpg",
      block1Title: "Professionelt udført værkstedsarbejde",
      block1Text: "Se et udvalg af vores gennemførte projekter – fra specialeopgaver og fejlsøgninger til omfattende motorrenoveringer.",
      block2Title: "Kvalitet du kan stole på hver gang",
      block2Text: "Vi lægger stolthed i hvert eneste projekt på Sakskærvej. Kontakt os gerne for at drøfte din næste opgave.",
      buttonText: "Kontakt os for tilbud",
      buttonLink: "/kontakt/"
    }
  },
  "kontakt": {
    tagline: "Service og reparation til fair priser — uden overraskelser",
    headerBlock: {
      block1Title: "Vi står klar til at hjælpe dig i Varde",
      block1Text: "Har du spørgsmål, brug for et uforpligtende tilbud eller ønsker du at booke tid på værkstedet? Vi hjælper dig hurtigt videre.",
      block2Title: "Ærlig rådgivning og hurtig respons",
      block2Text: "Vi besvarer alle henvendelser hurtigt og giver dig gennemskuelig rådgivning om din bils behov."
    },
    splitCard: {
      image: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/496749061-17877993531318194-1459227221856858672-n-1000x1000.jpg",
      block1Title: "Besøg os på Sakskærvej 75 i Varde",
      block1Text: "Vores værksted er let tilgængeligt, og du er altid velkommen til at kigge forbi til en uforpligtende snak om din bil.",
      block2Title: "Ring direkte eller skriv til os",
      block2Text: "Fang os på telefon 23 95 27 06 for direkte kontakt eller send en e-mail på sakskaer-auto@outlook.dk.",
      buttonText: "Ring: 23 95 27 06",
      buttonLink: "tel:23952706"
    }
  }
}

export const PAGES_DATA = {
  index: {
    slug: "",
    title: "kvalitet, tryghed og god service | Sakskær Auto",
    metaDescription: "kvalitet, tryghed og god service. Kontakt Sakskær Auto i dag!",
    heroTitle: "Vi holder dig kørende – sikkert og effektivt",
    heroTag: "Velkommen til Sakskær Auto",
    heroSub: "Vi bruger moderne udstyr og kvalitetsdele, så bilen holder længere.",
    heroImage: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/20250705-133330-scaled.jpg",
    sectionSub: "Din bil fortjener den bedste pleje",
    sectionTitle: "Dit lokale autoværksted – kvalitet, tryghed og god service",
    sectionText: "Hos os er din bil i sikre hænder. Vi tilbyder professionel service og reparation af alle bilmærker – altid med fokus på kvalitet, gennemsigtighed og fair priser.",
    servicesListTitle: "Vores ydelser omfatter:",
    servicesList: [
      "Serviceeftersyn og fejlfinding",
      "Reparation af motor, bremser, kobling og undervogn",
      "Dæk- og hjulskift samt opbevaring",
      "Aircondition-service og udstødning",
      "Synstjek og klargøring"
    ],
    sectionText2: "Vi bruger moderne udstyr og originale eller kvalitetsgodkendte reservedele, så du kan være tryg ved, at din bil kører optimalt og sikkert.",
    serviceCards: [
      {
        title: "Dæk og fælge",
        desc: "Hos Sakskær Auto i Varde tilbyder vi alt inden for dæk og fælge til konkurrencedygtige priser.",
        link: "/daek-og-faelge/"
      },
      {
        title: "Gearkasse service",
        desc: "Hos Sakskær Auto i Varde anbefaler vi gearkasse service – også på biler, hvor producenten ikke har fastsat officielle intervaller.",
        link: "/gearkasse-service/"
      },
      {
        title: "Service",
        desc: "Hos Sakskær Auto i Varde tilbyder vi professionel bilservice efter producentens anvisninger, så du bibeholder bilens fabriksgaranti.",
        link: "/service/"
      }
    ],
    guaranteeSub: "Service og reparation til fair priser – uden overraskelser",
    guaranteeTitle: "Hos os får du altid:",
    guaranteeList: [
      "Ærlig rådgivning og klare aftaler",
      "Hurtig og effektiv service",
      "Dygtige mekanikere med stor erfaring",
      "Fokus på både kvalitet og pris"
    ],
    guaranteeCallout: "Book tid i dag, og oplev forskellen på et autoværksted, der sætter dig og din bil først!",
    gallerySlug: "forside-galleri"
  },

  "a-c-service": {
    slug: "a-c-service",
    title: "AC service | Sakskær Auto",
    metaDescription: "Din bil fortjener den bedste pleje A/C Service i Varde – Professionel aircondition service hos Sakskær Auto Hos Sakskær Auto i Varde tilbyder vi professionel A/C-service til alle typer biler – både benzin, diesel, hybrid og elbiler.",
    topTag: "Din bil fortjener den bedste pleje",
    mainHeading: "A/C service i Varde – professionel aircondition service hos Sakskær Auto",
    heroImage: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/imgi-17-bil-2-scaled.jpg",
    heroSub: "Hos Sakskær Auto i Varde tilbyder vi professionel A/C-service til alle typer biler – både benzin, diesel, hybrid og elbiler. Et velfungerende airconditionanlæg er ikke kun en luksus om sommeren, men en vigtig del af bilens komfort og sikkerhed året rundt.\n\nVi anbefaler, at du får foretaget et airconditionservice minimum hvert andet år for at sikre optimal drift, forlænge levetiden på systemet og undgå dyre reparationer.",
    intro: "Hos Sakskær Auto i Varde tilbyder vi professionel A/C-service til alle typer biler – både benzin, diesel, hybrid og elbiler. Et velfungerende airconditionanlæg er ikke kun en luksus om sommeren, men en vigtig del af bilens komfort og sikkerhed året rundt.\n\nVi anbefaler, at du får foretaget et airconditionservice minimum hvert andet år for at sikre optimal drift, forlænge levetiden på systemet og undgå dyre reparationer.",
    benefitsTitle: "Fordele ved regelmæssig A/C-service:",
    benefits: [
      "Bedre komfort og indeklima\nEt rent og effektivt A/C-system giver dig kølig og frisk luft – uden dårlig lugt, bakterier eller skimmelsvamp."
    ],
    section2Title: "Forebygger fejl og skader",
    section2Text: "Med tiden forsvinder kølemidlet naturally, hvilket kan føre til slid og dyre skader på kompressoren. Ved at holde systemet fyldt og vedligeholdt undgår du disse problemer.",
    section3Title: "Effektiv dugfjernelse",
    section3Text: "Et velfungerende airconditionanlæg hjælper med hurtigt at fjerne dug fra ruderne, hvilket forbedrer udsynet og øger sikkerheden.",
    section4Title: "Fejlfinding med brint – præcis og effektiv lækagesøgning",
    section4Text: "Hos Sakskær Auto anvender vi det nyeste testudstyr og har mulighed for at foretage præcis fejlfinding på utætte A/C-systemer med brint. Det gør det muligt at lokalisere selv de mindste utætheder hurtigt og sikkert – og sikre, at din bils aircondition virker optimalt igen.",
    section5Title: "Vi servicerer alle bilers A/C-anlæg",
    section5Text: "Uanset om du kører i en benzin-, diesel-, hybrid- eller elbil, kan vi servicere dit klimaanlæg. Vores udstyr er kompatibelt med alle gængse kølemidler, inklusive det nyere CO₂-system, som findes i nogle elbiler.",
    pricesTitle: "A/C-service – faste lave priser:",
    prices: [
      "Benzin- og dieselbiler: 649,- inkl. 100g kølemiddel\nHerefter kun 2,- pr. gram ekstra.",
      "El- og hybridbiler:\n949,- inkl. 100g kølemiddel\nHerefter kun 2,- pr. gram ekstra.",
      "Elbiler med CO₂-system: 1799,- inkl. fuld påfyldning."
    ],
    bottomTitle: "Dit lokale autoværksted i Varde – Sakskær Auto",
    bottomText: "Vi er din lokale specialist i airconditionservice i Varde, og vi står klar til at hjælpe dig med både service, reparation og fejlfinding af bilens klimaanlæg. Vi lægger vægt på kvalitet, ærlighed og moderne udstyr – så du kan føle dig tryg hele vejen.\n\nKontakt os i dag for at bestille tid til A/C-service – og kør med et klimaanlæg der virker!"
  },

  "daek-og-faelge": {
    slug: "daek-og-faelge",
    title: "Dæk og fælge | Sakskær Auto",
    metaDescription: "Din bil fortjener den bedste pleje Alt i dæk og fælge hos Sakskær Auto i Varde. Sommerdæk, vinterdæk, helårsdæk og fælge til personbiler og varevogne.",
    topTag: "Din bil fortjener den bedste pleje",
    mainHeading: "Alt i dæk og fælge hos Sakskær Auto i Varde",
    heroImage: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/483884455-122123454662418369-9044174517283196909-n.jpg",
    heroSub: "Vi tilbyder alt inden for dæk og fælge til konkurrencedygtige priser. Uanset om du har brug for sommerdæk, vinterdæk, helårsdæk eller fælge, står vi klar med professionel vejledning og montering.",
    intro: "Hos Sakskær Auto i Varde tilbyder vi alt inden for dæk og fælge til konkurrencedygtige priser. Uanset om du har brug for sommerdæk, vinterdæk, helårsdæk eller fælge til din personbil eller varevogn, står vi klar med professionel vejledning og service.\n\nVi sikrer, at dine dæk og fælge er monteret korrekt og fungerer optimalt – så du får maksimal sikkerhed og køreglæde.",
    listTitle: "Vores dækspecialist tilbyder:",
    list: [
      "Montering af dæk og fælge",
      "Afbalancering for optimal kørestabilitet",
      "Udskiftning og service af TPMS-ventiler (dæktryksovervågning)",
      "Rådgivning om de bedste dæk og fælge til din bil og kørselsbehov",
      "Konkurrencedygtige priser uden at gå på kompromis med kvaliteten"
    ],
    section2Title: "Hvorfor vælge Sakskær Auto til dine dæk og fælge?",
    list2: [
      "Vi har mange års erfaring og ekspertise med alle typer dæk og fælge",
      "Vi bruger moderne udstyr til præcis montering og afbalancering",
      "Vi sikrer, at dine TPMS-ventiler fungerer korrekt og opfylder fabrikantens krav",
      "Du får altid professionel og ærlig vejledning, der matcher dine behov og budget",
      "Hurtig og effektiv service, så du hurtigt kan komme sikkert videre"
    ],
    bottomTitle: "Sakskær Auto – Din lokale dækspecialist i Varde",
    bottomText: "Som dit lokale autoværksted i Varde sætter vi en ære i at tilbyde dæk og fælge af høj kvalitet med god service til fair priser. Kontakt os i dag, og få et uforpligtende tilbud på dine nye dæk eller fælge. Vi sørger for, at din bil er klar til vejen – sikkert og komfortabelt."
  },

  "gearkasse-service": {
    slug: "gearkasse-service",
    title: "Gearkasse service | Sakskær Auto",
    metaDescription: "Din bil fortjener den bedste pleje Gearkasse service hos Sakskær Auto i Varde – vigtigt for bilens holdbarhed og køreglæde.",
    topTag: "Din bil fortjener den bedste pleje",
    mainHeading: "Gearkasse service hos Sakskær Auto i Varde",
    heroImage: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/content-7-scaled.jpg",
    heroSub: "Vi anbefaler regelmæssig gearkasse service for at beskytte en af bilens mest belastede komponenter. Professionel vedligeholdelse forlænger gearkassens levetid og sikrer bløde gearskift.",
    intro: "Hos Sakskær Auto i Varde anbefaler vi gearkasse service – også på biler, hvor producenten ikke har fastsat officielle intervaller. Mange bilister overser gearkassen, men den er en af bilens mest belastede og vigtige komponenter, som fortjener regelmæssig pleje.",
    section2Title: "Hvorfor er gearkasse service vigtigt – selv uden faste intervaller?",
    section2Text: "Selvom mange moderne biler ikke har officielle anbefalinger for gearkasse service, kan gammel eller forurenet gearolie føre til øget slid og funktionsfejl. Gearkassen indeholder mange præcisionsdele, som kræver korrekt smøring for at fungere optimalt og undgå overophedning.",
    benefitsTitle: "Ved at få skiftet gearolie og efterset gearkassen regelmæssigt, kan du:",
    list: [
      "Forebygge dyre reparationer og slid på gearkomponenter",
      "Sikre en mere jævn og præcis gearskiftoplevelse",
      "Forlænge gearkassens levetid og optimere bilens ydeevne",
      "Undgå fejl og problemer med automatiske eller manuelt betjente gearkasser"
    ],
    section3Title: "Professionel gearkasse service hos Sakskær Auto",
    section3Text: "Vi bruger det nyeste udstyr og kvalitetsgearolie, der passer præcist til din bilmodel. Vores erfarne mekanikere tjekker gearkassen grundigt og rådgiver dig om den bedste løsning – altid med fokus på at sikre, at din bil kører trygt og problemfrit.",
    bottomTitle: "Bestil gearkasse service i dag – undgå fremtidige problemer",
    bottomText: "Hos Sakskær Auto i Varde kan du få udført gearkasse service hurtigt og effektivt. Mange gange kan en simpel service spare dig for store udgifter senere.\n\nKontakt os i dag og få en tid til gearkasse service – vi hjælper dig med at passe på din bil."
  },

  "gearkasse-skylning": {
    slug: "gearkasse-skylning",
    title: "Gearkasse skylning | Sakskær Auto Varde",
    metaDescription: "Din bil fortjener den bedste pleje. Professionel gearkasse skylning hos Sakskær Auto i Varde. 100% udskiftning af gearolie for bløde gearskift og lang levetid.",
    topTag: "DIN BIL FORTJENER DEN BEDSTE PLEJE",
    mainHeading: "GEARKASSE SKYLNING HOS SAKSKÆR AUTO I VARDE – EFFEKTIV RENS AF AUTOMATGEARKASSE",
    heroImage: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/gearkasse-skylning.jpg",
    heroSub: "Hos Sakskær Auto i Varde tilbyder vi professionel gearkasse skylning til alle biler med automatgear. En gearkasse skylning er en dybdegående og effektiv rensning af bilens automatgearkasse, hvor 100% af den gamle gearolie udskiftes med frisk olie af højeste kvalitet.\n\nOver tid nedbrydes gearolien af høj varme, friktion og sod, hvilket kan føre til ru og uklare gearskift, tøven ved acceleration samt øget slid på de indvendige komponenter. Ved at få udført en professionel gearkasse skylning sikrer du, at din automatgearkasse igen arbejder smidigt og effektivt.",
    intro: "Hos Sakskær Auto i Varde tilbyder vi professionel gearkasse skylning til alle typer automatgearkasser. Ved et almindeligt olieskift udskiftes kun cirka halvdelen af olien, mens resten forbliver i converteren og oliekøleren.\n\nMed vores specialudstyr skylles hele systemet igennem, så sod, aflejringer og forurenet olie fjernes fuldstændigt før ny godkendt gearolie påfyldes.",
    listTitle: "FORDELE VED AUTOMATGEARKASSE SKYLNING:",
    list: [
      "100% udskiftning af den forurenede gearolie samt rens af ventilhus og converter",
      "Afhjælper ru, hårde eller tøvende gearskift og ubehagelige ryk",
      "Forebygger dyre reparationer og forlænger automatgearkassens levetid markant",
      "Optimerer brændstoføkonomien og sikrer maksimal kørekomfort"
    ]
  },

  kundebil: {
    slug: "kundebil",
    title: "Kundebil | Sakskær Auto",
    metaDescription: "Din bil fortjener den bedste pleje. Gratis lånebil hos Sakskær Auto i Varde – spørg ved booking.",
    topTag: "DIN BIL FORTJENER DEN BEDSTE PLEJE",
    mainHeading: "GRATIS LÅNEBIL HOS SAKSKÆR AUTO I VARDE – SPØRG VED BOOKING",
    heroImage: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/imgi-14-500818311-17880229317318194-6436614140921981671-n.jpg",
    heroSub: "Hos Sakskær Auto i Varde ved vi, hvor vigtigt det er at være mobil, selv når din bil er på værksted. Derfor tilbyder vi altid mulighed for gratis lånebil, når du får service eller reparation hos os.\n\nNår du booker tid til din bil, så husk at spørge efter en gratis lånebil – så sørger vi for, at du kan komme rundt, mens vi passer på din bil.",
    intro: "Hos Sakskær Auto i Varde ved vi, hvor vigtigt det er at være mobil, selv når din bil er på værksted. Derfor tilbyder vi altid mulighed for gratis lånebil, når du får service eller reparation hos os.\n\nNår du booker tid til din bil, så husk at spørge efter en gratis lånebil – så sørger vi for, at du kan komme rundt, mens vi passer på din bil.",
    listTitle: "HVORFOR VÆLGE SAKSKÆR AUTO?",
    list: [
      "Professionelt autoværksted i Varde med mange års erfaring",
      "Gratis lånebil ved service og reparation – for din bekvemmelighed",
      "Hurtig og effektiv service, så du ikke er uden bil længere end højst nødvendigt",
      "Professionel rådgivning og kvalitetsarbejde med det nyeste udstyr"
    ],
    section2Title: "Hvorfor vælge Sakskær Auto?",
    section3Title: "Sakskær Auto – dit lokale autoværksted i Varde",
    section3Text: "Vi ønsker at gøre det så nemt som muligt for dig at få din bil serviceret eller repareret. Med en gratis lånebil sikrer vi, at du ikke bliver sat tilbage i din hverdag.\n\nKontakt Sakskær Auto i dag, og bestil tid til service – husk at spørge efter din gratis lånebil ved booking!"
  },

  reparation: {
    slug: "reparation",
    title: "Reparation | Sakskær Auto",
    metaDescription: "Sakskær Auto – Dit autoværksted i Varde med fokus på professionalisme, godt håndværk og ærlige aftaler.",
    topTag: "Din bil fortjener den bedste pleje",
    mainHeading: "Professionel bilreparation hos Sakskær Auto",
    heroImage: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/imgi-14-rep-eller-tilfaeldigt-sted-2-scaled.jpg",
    heroSub: "Hos Sakskær Auto i Varde får du et autoværksted med fokus på professionalisme, godt håndværk og ærlige aftaler. Vi servicerer og reparerer alle typer biler – altid med omhu og det nyeste udstyr.",
    intro: "Hos Sakskær Auto i Varde får du et autoværksted med fokus på professionalisme, godt håndværk og ærlige aftaler. Vi servicerer og reparerer alle typer biler – altid med omhu, præcision og det nyeste udstyr på markedet.\n\nNår du vælger os, vælger du et værksted, hvor en aftale er en aftale, og hvor vi udelukkende bruger kvalitetsreservedele for at sikre holdbare og sikre løsninger.",
    section2Title: "Derfor vælger kunder Sakskær Auto i Varde:",
    highlights: [
      {
        title: "Professionel og erfaren mekaniker",
        text: "Vi har mange års erfaring og ved, hvad din bil har brug for. Uanset om det gælder service, fejlfinding eller reparation, kan du forvente faglig rådgivning og solidt håndværk."
      },
      {
        title: "Det nyeste udstyr",
        text: "Moderne biler kræver moderne udstyr. Vi investerer løbende i det nyeste diagnose- og værkstedsudstyr, så vi hurtigt og præcist kan finde og løse problemer."
      },
      {
        title: "Aftaler der holder",
        text: "Hos Sakskær Auto får du ærlige svar og faste priser. Vi overholder altid det, vi aftaler – både med hensyn til tid og pris."
      },
      {
        title: "Fokus på godt håndværk og kvalitet",
        text: "Vi går aldrig på kompromis. Alle reparationer og services udføres med stor omhu – og vi bruger udelukkende kvalitetsreservedele, så du får en løsning, der holder i længden."
      }
    ],
    section3Title: "Vores værksted tilbyder bl.a.:",
    list: [
      "Serviceeftersyn og olieskift",
      "Reparation af bremser og undervogn",
      "Udskiftning af tandrem og taktkæde",
      "Koblingsskift",
      "Fejlfinding og diagnose",
      "A/C-service"
    ],
    section4Title: "Klargøring til syn",
    section4Text: "Alt i dæk og fælge – inkl. montering, afbalancering og opbevaring\n\nGenerelt mekanisk arbejde på alle bilmærker og modeller"
  },

  service: {
    slug: "service",
    title: "Service efter bogen hos Sakskær Auto – Bevar din fabriksgaranti | Sakskær Auto",
    metaDescription: "Service efter bogen hos Sakskær Auto – Bevar din fabriksgaranti. Professionel bilservice i Varde efter producentens anvisninger.",
    topTag: "Din bil fortjener den bedste pleje",
    mainHeading: "Service efter bogen hos Sakskær Auto – Bevar din fabriksgaranti",
    heroImage: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/imgi-14-tilfaeldigt-scaled.jpg",
    heroSub: "Hos Sakskær Auto i Varde tilbyder vi professionel bilservice efter producentens anvisninger, så du bibeholder bilens fabriksgaranti – præcis som hvis du brugte mærkeværkstedet.\n\nVi ved, hvor vigtigt det er, at din bil er pålidelig og i god stand, uanset om du pendler hver dag, bruger bilen til familien eller bare skal være sikker på, at den starter hver gang. Derfor går vi aldrig på kompromis med kvaliteten – hverken i arbejdet eller de dele, vi bruger.",
    section2Title: "Fabriksgaranti? Intet problem",
    section2Text: "Mange tror fejlagtigt, at man skal bruge et autoriseret mærkeværksted for at bevare garantien. Det passer ikke. Når du får lavet service efter bilfabrikantens forskrifter – som vi altid gør hos Sakskær Auto – forbliver din garanti gyldig.\n\nVi følger alle intervaller, bruger korrekte specifikationer og dokumenterer alt arbejdet grundigt ved at stemple bilens originale eller online servicebog. Det sikrer dig fuld dokumentation og tryghed, hvis du skal bruge garantien eller sælge bilen videre.",
    intro: "Hos Sakskær Auto i Varde tilbyder vi professionel bilservice efter producentens anvisninger, så du bibeholder bilens fabriksgaranti – præcis som hvis du brugte mærkeværkstedet.\n\nVi ved, hvor vigtigt det er, at din bil er pålidelig og i god stand, uanset om du pendler hver dag, bruger bilen til familien eller bare skal være sikker på, at den starter hver gang. Derfor går vi aldrig på kompromis med kvaliteten – hverken i arbejdet eller de dele, vi bruger.",
    section2Title: "Fabriksgaranti? Intet problem",
    section2Text: "Mange tror fejlagtigt, at man skal bruge et autoriseret mærkeværksted for at bevare garantien. Det passer ikke. Når du får lavet service efter bilfabrikantens forskrifter – som vi altid gør hos Sakskær Auto – forbliver din garanti gyldig.\n\nVi følger alle intervaller, bruger korrekte specifikationer og dokumenterer alt arbejdet grundigt ved at stemple bilens originale eller online servicebog. Det sikrer dig fuld dokumentation og tryghed, hvis du skal bruge garantien eller sælge bilen videre.",
    section3Title: "Kun reservedele af højeste kvalitet",
    section3Text: "Vi anvender udelukkende reservedele af bedste kvalitet, som matcher eller overgår producentens egne krav. Det betyder, at du får en langtidsholdbar løsning, hvor du ikke skal bekymre dig om slid, svigt eller følgeskader.\n\nDu får altså den samme tryghed som på mærkeværkstedet – bare til en fair pris og med ærlig rådgivning.",
    section4Title: "Vi ved, din bil skal være til at stole på",
    section4Text: "Din bil skal starte, når du drejer nøglen. Den skal kunne klare hverdagens krav uden problemer – og den skal være sikker for dig og din familie. Hos Sakskær Auto forstår vi det ansvar, der følger med et serviceeftersyn. Derfor får du:",
    list: [
      "Kvalitet og præcision i alt vi laver",
      "Service uden genveje eller halve løsninger",
      "Ærlige vurderinger og faste priser",
      "Et værksted, der respekterer både din bil og din tid"
    ],
    bottomTitle: "Sakskær Auto – Dit autoværksted i Varde",
    bottomText: "Vi er dit lokale valg, når du ønsker bilservice med høj kvalitet, fabriksrigtige intervaller og fuld gennemsigtighed. Uanset bilmodel eller mærke, sørger vi for, at din bil bevarer sin værdi, garanti og driftssikkerhed.\n\nKontakt os i dag, og få en tid til service – så du kan køre trygt videre."
  },

  "udskiftning-af-tandrem-og-taktkaede": {
    slug: "udskiftning-af-tandrem-og-taktkaede",
    title: "Udskiftning af tandrem og taktkæde | Sakskær Auto",
    metaDescription: "Udskiftning af tandrem og taktkæde i Varde – Tryghed og ekspertise hos Sakskær Auto.",
    topTag: "Din bil fortjener den bedste pleje",
    mainHeading: "Udskiftning af tandrem og taktkæde i Varde",
    heroImage: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/20240619-101805-750x1000.jpg",
    heroSub: "Specialister i udskiftning af tandremme og taktkæder på alle bilmærker. Undgå dyre motorreparationer ved at få skiftet tandrem og taktkæde i god tid.",
    intro: "Hos Sakskær Auto i Varde er vi specialister i udskiftning af tandremme og taktkæder på alle bilmærker. Uanset om din bil er udstyret med tandrem eller taktkæde, er det vigtigt at få tjekket og vedligeholdt motorens drivsystem i tide – før det ender i dyre motorreparationer.\n\nVi tilbyder professionel rådgivning og gennemsigtig service – så du ved præcis, hvornår og hvorfor det er tid til at skifte.",
    section2Title: "Tandrem – hvorfor skal den skiftes i tide?",
    section2Text: "Tandremmen er en sliddel, som holder motorens bevægelige dele synkroniseret. Hvis den springer, kan det medføre alvorlige skader på motoren – i værste fald totalskade.\n\nDe fleste biler har et fast udskiftningsinterval, f.eks. hver 5-8 år eller efter et bestemt antal kilometer. Hos Sakskær Auto holder vi styr på dette for dig – så du ikke bliver overrasket.",
    section3Title: "Taktkæde – ikke altid “vedligeholdelsesfri”",
    section3Text: "Mange tror, at en taktkæde er vedligeholdelsesfri og aldrig skal skiftes – men det er desværre en udbredt misforståelse.\n\nTaktkæder kan over tid blive strakte, slide kædestrammeren op eller begynde at støje. Det kan føre til forkert tænding, nedsat motorydelse eller alvorlige motorskader, hvis kæden springer eller hopper over.",
    section4Title: "Vi anbefaler regelmæssige tjek, især hvis du oplever symptomer som:",
    list: [
      "Raslende lyd fra motoren ved koldstart",
      "Motorfejl eller tændingsproblemer",
      "Uregelmæssig motorgang"
    ],
    section4Subtext: "Hos Sakskær Auto kan vi hurtigt vurdere kædens tilstand og rådgive dig om behov for udskiftning – også selvom bilen ikke har et officielt skifteinterval.",
    bottomTitle: "Sakskær Auto – dit lokale værksted i Varde",
    bottomText: "Uanset om din bil kører med tandrem eller taktkæde, står vi klar til at hjælpe dig med professionel udskiftning og service. Vi servicerer både benzin-, diesel-, hybrid- og elbiler – og vi går aldrig på kompromis med kvaliteten.\n\nKontakt os i dag for et uforpligtende tilbud på tandrem eller taktkæde-udskiftning – og kør trygt videre med en motor i topform."
  },

  "walnut-blaster": {
    slug: "walnut-blaster",
    title: "Walnut blaster | Sakskær Auto",
    metaDescription: "Rensning af indsugning med Walnut Blaster hos Sakskær Auto i Varde. Dybdegående rensning med nøddeskalsplinter.",
    topTag: "Din bil fortjener den bedste pleje",
    mainHeading: "Rensning af indsugning med Walnut Blaster",
    heroImage: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/foer.jpg",
    heroSub: "Professionel og skånsom rensning af bilens indsugningssystem med den avancerede Walnut Blaster-teknologi. Genovervinder motorkraft, forbedrer brændstoføkonomien og fjerner koksophobninger.",
    intro: "Hos Sakskær Auto i Varde tilbyder vi professionel og effektiv rensning af indsugningssystemer med den avancerede Walnut Blaster-teknologi. Denne metode er ideel til at fjerne sodophobninger, som kan samle sig i indsugningskanaler og påvirke motorkraften.",
    section2Title: "Hvorfor vælge Walnut Blaster til indsugningsrensning?",
    section2Text: "Walnut Blaster er en skånsom, men kraftfuld rengøringsmetode, der bruger finvalsede nøddeskalsplinter til at fjerne ophobet sod og snavs. Denne teknik sikrer en dybdegående rengøring uden at skade motordelen eller indre dele, hvilket gør den til et sikkert og miljøvenligt valg.",
    section3Title: "Fordele ved rensning af indsugning med Walnut Blaster",
    list: [
      "Forbedret motoreffektivitet: Fjernelse af ophobet sod og snavs betyder, at luften kan cirkulere frit, hvilket forbedrer motorydelsen.",
      "Øget brændstoføkonomi: En ren indsugning hjælper med at optimere brændstofforbruget, hvilket sparer dig penge.",
      "Reduktion af emissioner: En renere indsugning bidrager til lavere udledning af skadelige stoffer.",
      "Forebyggelse af motorskade: Regelmæssig rengøring minimerer risikoen for motorskader og forlænger levetiden på dit køretøj."
    ],
    section4Title: "Hvornår er det nødvendigt at få renset indsugningen?",
    section4Text: "Hvis du oplever problemer som kraftig røgudvikling, nedsat kraft, eller hvis motorydelsen føles hæmmet, kan det være tegn på, at indsugningen trænger til rengøring. En rutinemæssig indsugningsrensning med Walnut Blaster anbefales også for at opretholde din bils optimale funktion.",
    gallerySlug: "walnut-blaster-galleri",
    galleryImages: [
      { src: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/foer.jpg", alt: "før" },
      { src: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/efter.jpg", alt: "efter" }
    ]
  },

  reference: {
    slug: "reference",
    title: "Reference | Sakskær Auto",
    metaDescription: "Se flere af vores projekter og referencer her.",
    topTag: "Sakskær Auto",
    mainHeading: "Referencer & Projekter – Skræddersyede løsninger",
    heroImage: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/tilfaeldigt-sted-750x1000.jpg",
    heroSub: "Vores kunder har alle forskellige behov, og derfor tilbyder vi altid skræddersyede løsninger med udgangspunkt i hver enkelte kundes ønsker. Se et udvalg af vores arbejde her.",
    text1: "Vores kunder har alle forskellige behov, og derfor tilbyder vi altid skræddersyede løsninger med udgangspunkt i hver enkelte kundes ønsker. Inden vi går i gang, forventningsafstemmer vi med dig, så vi kan levere et resultat, der lever op til dine forventninger. Se vores projekter og referencer her.",
    title2: "Kompetent rådgivning",
    text2: "Er du i tvivl om, hvilken løsning der er den bedste for dig? Det skal du ikke bekymre dig om. Vi tilbyder kompetent rådgivning i forbindelse med ethvert projekt og holder dig opdateret fra start til slut. Du er i trygge hænder hos os.",
    gallerySlug: "reference-galleri",
    galleryImages: [
      { src: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/placeholder.jpg", alt: "Referencer" }
    ]
  },

  kontakt: {
    slug: "kontakt",
    title: "Kontakt | Sakskær Auto",
    metaDescription: "Har du spørgsmål eller kommentarer? Kontakt os i dag for at høre mere om, hvad vi kan gøre for dig.",
    topTag: "Kør trygt videre med vores hjælp",
    mainHeading: "Kontakt Sakskær Auto i Varde",
    heroImage: "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/496749061-17877993531318194-1459227221856858672-n-1000x1000.jpg",
    heroSub: "Har du spørgsmål, brug for et tilbud eller vil du booke tid på værkstedet? Vi står altid klar til at hjælpe dig med professionel rådgivning og god service.",
    subtitle: "Vores kontaktinformationer",
    subtext: "Har du spørgsmål eller ønsker du et uforpligtende tilbud?\nKontakt os allerede i dag for kompetent sparring og rådgivning ved din opgave."
  }
}
